// extracted by mini-css-extract-plugin
export default {"dimension":"IRYnb","name":"yNLQf","value":"nXZCC","valueItem":"nciZt","vertical":"o7LT_","valueName":"hOuvM","narrow":"qhSXk","valueValue":"cJeDP","delimiter":"HbIK4"};